module.exports = __webpack_public_path__ + "img/client_6.2e51134d.png";